import { __awaiter, __decorate, __metadata } from "tslib";
import { Action, Module, Mutation, VuexModule } from 'vuex-module-decorators';
export const fuelPurchaseModuleName = 'fuelPurchaseStore';
let FuelPurchaseModule = class FuelPurchaseModule extends VuexModule {
    constructor() {
        super(...arguments);
        this.filteredElements = 0;
        this.items = [];
        this.pageNumber = 1;
        this.totalElements = 0;
    }
    get getFilteredElements() {
        return this.filteredElements;
    }
    get getItems() {
        return this.items;
    }
    get getPageNumber() {
        return this.pageNumber;
    }
    get getTotalElements() {
        return this.totalElements;
    }
    init(fuelPurchases) {
        return __awaiter(this, void 0, void 0, function* () {
            this.context.commit('setElements', fuelPurchases.filteredElements);
            this.context.commit('setItems', fuelPurchases.items);
            this.context.commit('setPageNumber', fuelPurchases.pageNumber);
            this.context.commit('setTotalElements', fuelPurchases.totalElements);
        });
    }
    setElements(filteredElements) {
        this.filteredElements = filteredElements;
    }
    setItems(items) {
        this.items = items;
    }
    setPageNumber(pageNumber) {
        this.pageNumber = pageNumber;
    }
    setTotalElements(totalElements) {
        this.totalElements = totalElements;
    }
};
__decorate([
    Action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", Promise)
], FuelPurchaseModule.prototype, "init", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FuelPurchaseModule.prototype, "setElements", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], FuelPurchaseModule.prototype, "setItems", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FuelPurchaseModule.prototype, "setPageNumber", null);
__decorate([
    Mutation,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], FuelPurchaseModule.prototype, "setTotalElements", null);
FuelPurchaseModule = __decorate([
    Module({
        name: fuelPurchaseModuleName,
        namespaced: true,
        stateFactory: true,
    })
], FuelPurchaseModule);
export { FuelPurchaseModule };
